import { useState, useCallback } from 'react';

export function useImportHistorySelection<T>() {
  const [selectedRows, setSelectedRows] = useState<T[]>([]);

  const handleSelectionChanged = useCallback((rows: T[]) => {
    setSelectedRows(rows);
  }, []);

  return {
    selectedRows,
    handleSelectionChanged,
    setSelectedRows,
  };
}
